// export const GetSuperAdminDashboard = `query GetSuperAdminDashboard {
//   getSuperAdminDashboard {
//     centralStoreCount
//     categoryCount
//     productCount
//   }
// }`
export const GetSystemConfigs = `
query GetSystemConfigs {
  getSystemConfigs {
    _id
    name
    value
    description
    contents
    isActive
  }
}`
export const GetProduct = `
query GetProduct($productId: String!) {
  getProduct(productId: $productId) {
    _id
    name
    description
    aliases
    images
    defaultImage
    isActive
    category {
      _id
      name
      isActive
      images
      subcategories {
        _id
        name
        description
        isActive
        images
        categoryId
      }
      description
    }
    catalog {
      _id
      name
      description
      isActive
      parcelable
    }
    sortOrder
    catalogDefault
    hsn
    CGST
    IGST
    SGST
    Exempted
    isNewProduct
    displayName
    skus {
      _id
      storeId
      productId
      discount
      barcode
      isActive
      mrp
      prices {
        customerType
        sellingPrice
      }
      unit
      measure
      minimumQty
      stockId
      stockUnits
      Stock {
        _id
        storeId
        quantity
        name
        store
      }
      localStocks {
        storeId
        skuId
        quantity
        replenishQty
        defaultLSQty
      }
    }
    offerImage
    offerEnabled
  }
}`
export const GetOrderDeliveryItemStats = `
query GetOrderDeliveryItemStats($start: String, $end: String) {
  getOrderDeliveryItemStats(start: $start, end: $end) {
    _id
    items {
      productId
      skuId
      name
      description
      image
      quantity
      mrp
      prices {
        customerType
        sellingPrice
      }
      status
      packingChecked
      billingChecked
    }
    orderAmount
    paymentMethod
    customerType
  }
}`
export const getDeliveryDatesForOrders = `
 query GetDeliveryDatesForOrders {
  getDeliveryDatesForOrders {
    deliveryString
    slotId
    date
  }
}
`;
export const GetRiderLockOrdersByTimeSlot =`
query GetRiderLockOrdersByTimeSlot($timeSlotId: String, $orderDate: String) {
  getRiderLockOrdersByTimeSlot(timeSlotId: $timeSlotId, orderDate: $orderDate) {
    _id
    items {
      productId
      skuId
      name
      description
      image
      quantity
      mrp
      sellingPrice
      prices {
        customerType
        sellingPrice
      }
      status
      measure
      unit
      packingChecked
      billingChecked
      oldSp
      oldCost
      refundString
    }
    customerType
    customer {
      _id
      name
      phone
      email
      gender
      nativePlace
      customerType
      isActive
      jwtToken
      refreshToken
      addresses {
        _id
        deliveryAddress
        details
        label
        selected
        isActive
      }
      status
      permittedPaymentOptions {
        method
        label
      }
      selectedPaymentMethod
      cart {
        orderDeliverySlot {
          deliveryString
          slotId
          date
        }
      }
      GST
      onlinePaymentProvider
      favourites
      canApplyReferral
      nestPassRenewalEnabled
      deviceModel
      deviceType
      deviceOS
    }
    paymentStatus
    paymentMethod
    onlinePaymentStatus
    paidAmount
    orderAmount
    orderDate
    deliveryDate
    billDetails {
      itemsTotal
      deliveryCharge
      grandTotal
      totalSaving
      handlingCharge
      itemSavings
      itemsMrp
      chargesWaived
      couponDiscount
      referralInfo {
        applied
        amount
        code
        message
        referrerId
        percentage
      }
      walletInfo {
        applied
        amount
        message
      }
      couponInfo {
        applied
        amount
        code
        message
        cancellationApplied
        limitRate
        daysRange
      }
      nestInfo {
        applied
        amount
        message
        couponRefundAmount
        couponRefundAccomodated
      }
      cancelledInfo {
          referralInfo {
            applied
            amount
            code
            message
            referrerId
            percentage
          }
          walletInfo {
            applied
            amount
            message
          }
          couponInfo {
            applied
            amount
            code
            message
            cancellationApplied
            limitRate
            daysRange
          }
          nestInfo {
            applied
            amount
            message
            couponCancellationAmount
            couponCancellationAccomodated
          }
        }
        refund
        premiumCustomerSaving
      }
    deliveryAddress {
      _id
      location {
        coordinates
      }
      deliveryAddress
      details
      label
      selected
      isActive
    }
    isOrderModified
    refundStatus
    canceledRefundStatus
    cancelledRefundAmount
    orderState {
      status
      workerStatus
      ppWorkerAssigned
      ppWorkerAssignedEmail
      billingWorkerAssigned
      billingWorkerAssignedEmail
      riderAssigned
      riderAssignedEmail
      lockedRider
      lockedRiderEmail
    }
    invoiceId
    deliveredImage
    customerDeliverySlot {
      name
      leadTime
      timeSlot {
        start
        end
        leadTime
        isActive
        _id
      }
    }
    deliveryModifications {
      from
      to
      by
      on
      reason
    }
    isOrderRejected
    orderRejectedReason
  }
}`
export const getInvoiceByOrderId = `
query Query($orderId: String) {
  getInvoiceByOrderId(orderId: $orderId)
}`
export const getCSOutOfStockProductReports=`
query GetCSOutOfStockProductReports($skip: Int!, $limit: Int!) {
  getCSOutOfStockProductReports(skip: $skip, limit: $limit) {
    reports {
      _id
      oosProducts {
        itemId
        name
        quantity
        minimumQty
        mrp
        skuId
        measure
        unit
        sortOrder
      }
      totalCount
      storeName
      storeId
      createdAt
    }
    totalCount
  }
}`
export const getCSOutOfStockProductReport=`
query GetCSOutOfStockProductReport($id: String!) {
  getCSOutOfStockProductReport(_id: $id) {
    _id
    oosProducts {
      itemId
      name
      quantity
      minimumQty
      mrp
      skuId
      measure
      unit
      sortOrder
    }
    totalCount
    storeName
    storeId
    createdAt
  }
}`
export const getMinPurchaseOffers = `
query GetMinPurchaseOffers {
  getMinPurchaseOffers {
    _id
    name
    minPurchaseAmount
    specialPriceProducts {
      productId
      skuId
      specialPrice
      maxQty
    }
    startDate
    endDate
    isActive
  }
}`
export const GetSpecialOffers = `
query GetSpecialOffers {
  getSpecialOffers {
    _id
    name
    action
    image
    displayStyle
    isActive
    updatedAt
    storeId
  }
}`
export const GetOrderDeliveryStats = `
query GetOrderDeliveryStats($start: String, $end: String) {
  getOrderDeliveryStats(start: $start, end: $end) {
    orderCount
    orderStat {
      skuId
      totalQuantity
      totalOrders
      name
      productId
      category
      subcategory
    }
    orderAmount
  }
}`
export const getQuotationResponse = `
query Query($quotationId: String!) {
  getQuotationResponse(quotationId: $quotationId)
}`
export const GetQuotationRefreshedData = `
query GetQuotationRefreshedData($skip: Int!, $limit: Int) {
  getQuotationRefreshedData(skip: $skip, limit: $limit) {
    quotationRefresh {
      _id
      name
      address
      phone
      invoiceDateString
      invoiceNo
      skus {
        slNo
        name
        _id
        productId
        stockId
        orderQuantity
        salesQuantity
        price
        total
        message
      }
      status
      generatedBy
      message
    }
    totalCount
  }
}`
export const getRefreshResponse = `
query Query($refreshId: String!) {
  getRefreshResponse(refreshId: $refreshId)
}`
export const getTaxResponse = `
query Query($taxId: String!) {
  getTaxResponse(taxId: $taxId)
}`
export const getTaxRefreshData = ` 
query getTaxRefreshData($skip: Int!, $limit: Int!) {
  getTaxRefreshData(skip: $skip, limit: $limit) {
    taxRefresh {
      _id
      storeId
      storeName
      generatedBy
      message
      createdAt
    }
    totalCount
  }
}`

export const GetRefreshedData = `
query GetRefreshedData($skip: Int!, $limit: Int) {
  getRefreshedData(skip: $skip, limit: $limit) {
    dataRefresh {
      _id
      storeId
      encodedResponse
      createdAt
    }
    totalCount
  }
}`
export const GetCustomerNestCash = ` 
query GetCustomerNestCash($customerId: String!, $skip: Int!, $limit: Int!) {
  getCustomerNestCash(customerId: $customerId, skip: $skip, limit: $limit) {
    customerId
    phone
    balance
    transactions {
      _id
      type
      accountingType
      orderId
      amount
      reason
      description
      nestBalance
      createdAt
      expiry
      expired
    }
    createdAt
    expiry
    isActive
    applyPercent
    activeTxnId
    totalTxnCount
    message
  }
}`
export const GetCustomerNestPass = ` 
query GetCustomerNestPass($customerPhone: String!, $skip: Int!, $limit: Int!) {
  getCustomerNestPass(customerPhone: $customerPhone, skip: $skip, limit: $limit) {
    code
    customerId
    customerPhone
    storeId
    firstMembershipDate
    membershipJoinDate
    membershipExpiryDate
    lastMembershipAmount
    lastMembershipUniqueId
    lastMembershipPaymentStatus
    lastMembershipOnlineTransactionId
    isActive
    lastMembershipType
    membershipStatus
    membershipStatusMessage
    refundTxnId
    refundStatus
    lastMembershipInvoiceId
    nestPassMembershipCount
    nestPassMemberships {
      membershipDate
      membershipExpiryDate
      type
      amount
      onlinePaymentProvider
      onlinePaymentStatus
      adminEmail
      cancelRefundPendingAmount
      canceledRefundStatus
      reason
      cancelledBy
      cancelledOn
      invoiceId
      internalId
    }
  }
}`
export const GetCustomerWalletByOrder = `
query GetCustomerWalletByOrder($orderId: String!, $skip: Int!, $limit: Int!) {
  getCustomerWalletByOrder(orderId: $orderId, skip: $skip, limit: $limit) {
    transactions {
      type
      orderId
      amount
      reason
      description
      balance
      createdAt
    }
    createdAt
    totalTxnCount
    message
    customerId
    balance
  }
}`
export const GetCustomerWallet = `
query GetCustomerWallet($customerId: String!, $skip: Int!, $limit: Int!) {
  getCustomerWallet(customerId: $customerId, skip: $skip, limit: $limit) {
    customerId
    balance
    transactions {
      type
      orderId
      amount
      reason
      description
      balance
      createdAt
    }
    createdAt
    totalTxnCount
    message
  }
}`
export const GetCustomerReferrelsHistory = `
query GetCustomerReferrelsHistory($phone: String!, $skip: Int!, $limit: Int!) {
  getCustomerReferrelsHistory(phone: $phone, skip: $skip, limit: $limit) {
    referrelsHistory {
      storeId
      code
      type
      referrerName
      referrer
      referrerPhone
      referee
      refereePhone
      refereeName
      orderId
      appliedDate
      registeredDate
      percentageApplied
      redeemedDate
      status
    }
    totalCount
  }
}`
export const GetReferralsHistoriesByCodeStatus = `
query GetReferralsHistoriesByCodeStatus($code: String!, $status: Int!, $start: String!, $end: String!, $skip: Int!, $limit: Int!) {
  getReferralsHistoriesByCodeStatus(code: $code, status: $status, start: $start, end: $end, skip: $skip, limit: $limit) {
    referrelsHistory {
      storeId
      code
      type
      referrerName
      referrer
      referrerPhone
      referee
      refereePhone
      refereeName
      orderId
      appliedDate
      registeredDate
      percentageApplied
      redeemedDate
      status
    }
    totalCount
  }
}`
export const GetNestPassPurchasedCustomersByDateRange =`
query GetNestPassPurchasedCustomersByDateRange($startDate: String!, $endDate: String!, $skip: Int!, $limit: Int!) {
  getNestPassPurchasedCustomersByDateRange(startDate: $startDate, endDate: $endDate, skip: $skip, limit: $limit) {
    nestPassPurchasedCustomers {
      customerName
      customerPhone
      purchaseDate
      expiryDate
      statusMessage
      amount
    }
    totalCount
    totalPurchaseAmount
    storeName
    nestPassDurationInMonths
    nestPassRegularPurchasePrice
    nestPassDiscountedPurchasePrice
  }
}`
export const SearchOrdersById=`
query SearchOrdersById($orderId: String!, $limit: Int!, $skip: Int!) {
  searchOrdersById(orderId: $orderId, limit: $limit, skip: $skip) {
    orders {
      _id
      customerId
      customerName
      customerPhone
      customerType
      orderDate
      deliveryDate
      completionTime
      itemsCount
      orderStatus
      orderAmount
      localStore
      centralStore
      deliveryAddress {
        _id
        location {
          coordinates
        }
        deliveryAddress
        details
        label
        selected
        isActive
      }
      invoiceId
      paymentMethod
      deliveredImage
      paymentStatus
      isOrderRejected
      orderRejectedReason
      refundStatus
      canceledRefundStatus
      orderState {
        status
        workerStatus
        ppWorkerAssigned
        ppWorkerAssignedEmail
        billingWorkerAssigned
        billingWorkerAssignedEmail
        riderAssigned
        riderAssignedEmail
        lockedRider
        lockedRiderEmail
      }
    }
    totalCount
  }
}`

export const searchOrdersByIdNamePhone=`
query SearchOrdersByIdNamePhone($orderId: String, $name: String, $phone: String, $limit: Int!, $skip: Int!) {
  searchOrdersByIdNamePhone(orderId: $orderId, name: $name, phone: $phone, limit: $limit, skip: $skip) {
    orders {
      _id
      customerId
      customerName
      customerPhone
      customerType
      orderDate
      deliveryDate
      completionTime
      itemsCount
      orderStatus
      orderAmount
      localStore
      centralStore
      deliveryAddress {
        _id
        location {
          coordinates
        }
        deliveryAddress
        details
        label
        selected
        isActive
      }
      invoiceId
      paymentMethod
      deliveredImage
      paymentStatus
      isOrderRejected
      orderRejectedReason
      refundStatus
      canceledRefundStatus
      orderState {
        status
        workerStatus
        ppWorkerAssigned
        ppWorkerAssignedEmail
        billingWorkerAssigned
        billingWorkerAssignedEmail
        riderAssigned
        riderAssignedEmail
        lockedRider
        lockedRiderEmail
      }
    }
    totalCount
  }
}`

export const SearchCustomers=`
query SearchCustomers($text: String!, $limit: Int!, $skip: Int!) {
  searchCustomers(text: $text, limit: $limit, skip: $skip) {
  customers {
      _id
      name
      phoneNumber
      addresses {
        _id
        location {
          coordinates
        }
        deliveryAddress
        details
        label
        selected
        isActive
      }
      orderCount
      customerType
    }
    totalCount
  }
}`
export const SearchCatalogs = `
query SearchCatalogs($text: String!, $limit: Int!, $skip: Int!) {
  searchCatalogs(text: $text, limit: $limit, skip: $skip) {
    catalogs {
      _id
      name
      description
      isActive
      parcelable
    }
    totalCount
  }
}`

export const SearchCategories = `
query SearchCategories($text: String!, $limit: Int!, $skip: Int!) {
  searchCategories(text: $text, limit: $limit, skip: $skip) {
    categories {
      _id
      name
      isActive
      images
      subcategories {
        _id
        name
        description
        isActive
        images
        categoryId
      }
      description
    }
    totalCount
  }
}`

export const SearchProducts = `
query SearchProducts($text: String!, $limit: Int!, $skip: Int!) {
  searchProducts(text: $text, limit: $limit, skip: $skip) {
    products {
      _id
      name
      description
      aliases
      images
      defaultImage
      isActive
      category {
        _id
        name
        isActive
        images
        subcategories {
          _id
          name
          description
          isActive
          images
          categoryId
        }
        description
      }
      catalog {
        _id
        name
        description
        isActive
        parcelable
      }
      sortOrder
      catalogDefault
      hsn
      CGST
      IGST
      SGST
      isNewProduct
      displayName
      skus {
        _id
        storeId
        productId
        discount
        barcode
        isActive
        mrp
        prices {
          customerType
          sellingPrice
        }
        unit
        measure
        minimumQty
        stockId
        stockUnits
        Stock {
          _id
          storeId
          quantity
          name
          store
        }
        localStocks {
          storeId
          skuId
          quantity
          replenishQty
          defaultLSQty
        }
      }
      offerImage
      offerEnabled
    }
    totalCount
  }
}`
export const GetAllCoupons = `
query GetAllCoupons {
  getAllCoupons {
  name
    description
    storeId
    type
    isActive
    code
    start
    end
    applyAmount
    orderAmount
    limitRate
    daysRange
  }
}`
export const GetAllReferrals = `
query GetAllReferrals($skip: Int!, $limit: Int!) {
  getAllReferrals(skip: $skip, limit: $limit) {
    referrals {
      _id
      storeId
      type
      isActive
      code
      expiry
      refereeDiscountPecentage
      referrerAmount
      referrerPercent
      referrerEventName
      referredEventRegisterdCount
      referredEventAppliedCount
      referredEventRedeemedCount
    }
    count
  }
}`
export const FilterProductsByCategories = `
query FilterProductsByCategories($skip: Int!, $categoryId: String, $subCategoryId: String, $text: String, $limit: Int) {
  filterProductsByCategories(skip: $skip, categoryId: $categoryId, subCategoryId: $subCategoryId, text: $text, limit: $limit) {
    products {
      _id
      name
      description
      aliases
      images
      defaultImage
      isActive
      category {
        _id
        name
        isActive
        images
        subcategories {
          _id
          name
          description
          isActive
          images
          categoryId
        }
        description
      }
      catalog {
        _id
        name
        description
        isActive
        parcelable
      }
      sortOrder
      hsn
      isNewProduct
      displayName
      skus {
        _id
        storeId
        productId
        discount
        barcode
        isActive
        mrp
        prices {
          customerType
          sellingPrice
        }
        unit
        measure
        minimumQty
        stockId
        stockUnits
        Stock {
          _id
          storeId
          quantity
          name
          store
        }
        localStocks {
          storeId
          skuId
          quantity
          replenishQty
          defaultLSQty
        }
      }
      offerImage
      offerEnabled
    }
    totalCount
  }
}`
export const GetCustomerDetailsById = `
query GetCustomerDetailsById($customerId: String!) {
  getCustomerDetailsById(customerId: $customerId) {
    _id
    name
    phone
    email
    gender
    nativePlace
    customerType
    isActive
    jwtToken
    refreshToken
    addresses {
      _id
      location {
        coordinates
      }
      deliveryAddress
      details
      label
      selected
      isActive
    }
    status
    permittedPaymentOptions {
      method
      label
    }
    selectedPaymentMethod
    cart {
      items {
        productId
        skuId
        name
        description
        image
        quantity
        mrp
        prices {
          customerType
          sellingPrice
        }
        status
      }
      deliveryAddress {
        _id
        deliveryAddress
        details
        label
        selected
        isActive
      }
      billDetails {
        itemsTotal
        deliveryCharge
        couponDiscount
        grandTotal
        totalSaving
        handlingCharge
        itemSavings
        itemsMrp
        chargesWaived
      }
    }
    GST
  }
}
`
export const GetAllCustomerTypes = `
query GetAllCustomerTypes {
  getAllCustomerTypes {
    name
    _id
    customerType
    description
    charges {
      handling {
        waiverAmount
        rate
      }
      delivery {
        waiverAmount
        rate
      }
    }
    storeCharges {
      localStoreId
      handling {
        minAmount
        maxAmount
        rate
      }
      delivery {
        minAmount
        maxAmount
        rate
      }
    }
    default
  }
}`
export const QueryDefaultCustomerType = `
query QueryDefaultCustomerType($latitude: String!, $longitude: String!) {
  queryDefaultCustomerType(latitude: $latitude, longitude: $longitude) {
    name
    _id
    customerType
    description
    charges {
      handling {
        waiverAmount
        rate
      }
      delivery {
        waiverAmount
        rate
      }
    }
    storeCharges {
      localStoreId
      handling {
        minAmount
        maxAmount
        rate
      }
      delivery {
        minAmount
        maxAmount
        rate
      }
    }
    default
  }
}`
export const GetRiderAllotmentReport = `
query GetRiderAllotmentReport($lsId: String!, $skip: Int!, $limit: Int!) {
  getRiderAllotmentReport(lsId: $lsId, skip: $skip, limit: $limit) {
   riderAllotments {
      assigned {
        orders {
          _id
          customerId
          customerPhone
          customerName
          deliveryAddress {
            _id
            location {
              coordinates
            }
            deliveryAddress
            details
            label
            selected
            isActive
          }
          deliveryDate
          orderAmount
          latitude
          longitude
        }
        riderEmail
        totalOrders
      }
      createdAt
      csId
      expansionRatio
      lsId
      message
      orders
      riders
      thresholdFactor
      unassigned {
        _id
        customerId
        customerPhone
        customerName
        deliveryAddress {
          _id
          location {
            coordinates
          }
          deliveryAddress
          details
          label
          selected
          isActive
        }
        deliveryDate
        orderAmount
        latitude
        longitude
      }
    }
    count
  }
}`

export const GetStore = `query GetStore($storeId: String!) {
  getStore(storeId: $storeId) {
  _id
    name
    type
    code
    address
    city
    location {
      coordinates
    }
    admins {
      _id
      name
      email
      phone
      userType
      isActive
      jwtToken
      createdBy
      storeId
      storeName
      contact_address
    }
    deliveryBounds {
      coordinates
    }
    landingPage {
      _id
      landingPageDisplays {
        deviceType
        _id
        displays {
          _id
          displayType
          enabled
          rows
          columns
          displayPosition
        }
      }
    }
    landingPageDisplayConfigs {
      _id
      displayName
      displayType
    }
    premiumCustomerConfig {
      purchaseAmount
      expiryInMonths
      daysOfPurchase
      activated
      message
    }
    removeUpgradedCustomerSlot {
      start
      end
      leadTime
      _id
    }
    nestPassExpiryNotificationSlot {
      start
      end
      leadTime
      _id
    }
    customerDeliverySlot {
      name
      timeSlot {
        start
        end
        leadTime
        isActive
        _id
      }
    }
    nestPass {
      code
      regularPurchasePrice
      discountedPurchasePrice
      hsn
      SGST
      CGST
      IGST
      gracePeriodForRenewal
      notificationForExpiration
      isActive
      expiryInMonths
      message
      nestPassExpiryReminderPushNotificationMessage
    }
    isActive
  }
}`
export const GetCentralStore = `
query GetCentralStore($storeId: String!) {
  getCentralStore(storeId: $storeId) {
    _id
    name
    type
    code
    address
    city
    location {
      coordinates
    }
    admins {
      _id
      name
      email
      phone
      userType
      isActive
      jwtToken
      createdBy
      storeId
      storeName
      contact_address
    }
    deliveryBounds {
      coordinates
    }
    landingPage {
      _id
      landingPageDisplays {
        deviceType
        _id
        displays {
          _id
          displayType
          enabled
          rows
          columns
          displayPosition
        }
      }
    }
  }
}`

export const getAllBanner = `
query GetBanner($isActive: Boolean) {
  getBanner(isActive: $isActive) {
    _id
    name
    contents {
      image
      action
    }
    isActive
    updatedAt
    storeId
  }
}
`
export const getorderFilter = `query GetAllOrdersByFilter($limit: Int!, $skip: Int!, $filterInput: FilterInput) {
  getAllOrdersByFilter(limit: $limit, skip: $skip, filterInput: $filterInput) {
    totalCount
    orders {
      _id
      customerId
      customerName
      customerPhone
      orderDate
      deliveryDate
      completionTime
      itemsCount
      orderStatus
      orderAmount
      localStore
      centralStore
      billDetails {
        itemsTotal
        deliveryCharge
        grandTotal
        totalSaving
        handlingCharge
        itemSavings
        itemsMrp
        chargesWaived
        couponDiscount
        referralInfo {
          applied
          amount
          code
          message
          referrerId
          percentage
        }
        walletInfo {
          applied
          amount
          message
        }
        couponInfo {
          applied
          amount
          code
          message
          cancellationApplied
          limitRate
          daysRange
        }
        nestInfo {
          applied
          amount
          message
          couponRefundAmount
          couponRefundAccomodated
        }
        cancelledInfo {
          referralInfo {
            applied
            amount
            code
            message
            referrerId
            percentage
          }
          walletInfo {
            applied
            amount
            message
          }
          couponInfo {
            applied
            amount
            code
            message
            cancellationApplied
            limitRate
            daysRange
          }
          nestInfo {
            applied
            amount
            message
            couponCancellationAmount
            couponCancellationAccomodated
          }
        }
        refund
        premiumCustomerSaving
      }
      deliveryAddress {
        _id
        location {
          coordinates
        }
        deliveryAddress
        details
        label
        selected
        isActive
      }
      orderState {
        status
        workerStatus
        ppWorkerAssigned
        ppWorkerAssignedEmail
        billingWorkerAssigned
        billingWorkerAssignedEmail
        riderAssigned
        riderAssignedEmail
        lockedRider
        lockedRiderEmail
      }
      invoiceId
      deliveredImage
      paymentMethod
      paymentStatus
      deliveryModifications {
        from
        to
        by
        on
        reason
      }
    }
    totalCount
  }
}`

export const GetLocalStoreCustomerDeliverySlot=`
query GetLocalStoreCustomerDeliverySlot {
  getLocalStoreCustomerDeliverySlot {
    name
    leadTime
    timeSlot {
      start
      end
      leadTime
      isActive
      _id
    }
  }
}`
export const GetOrderedItemsByTimeSlot=`
query GetOrderedItemsByTimeSlot($timeSlotId: String, $orderDate: String, $orderStatus: Int, $skip: Int, $limit: Int) {
  getOrderedItemsByTimeSlot(timeSlotId: $timeSlotId, orderDate: $orderDate, orderStatus: $orderStatus, skip: $skip, limit: $limit) {
    timeSlotItems {
      productId
      productName
      totalQty
      totalOrders
      category
    }
    totalCount
    storeName
  }
}`
export const GetOrdersByTimeSlot=`
query GetOrdersByTimeSlot($timeSlotId: String, $orderDate: String, $orderStatus: Int) {
  getOrdersByTimeSlot(timeSlotId: $timeSlotId, orderDate: $orderDate, orderStatus: $orderStatus) {
    _id
    items {
      productId
      skuId
      name
      description
      image
      quantity
      mrp
      sellingPrice
      prices {
        customerType
        sellingPrice
      }
      status
      measure
      unit
      packingChecked
      billingChecked
      oldSp
      oldCost
      refundString
    }
    customerType
    customer {
      _id
      name
      phone
      email
      gender
      nativePlace
      customerType
      isActive
      jwtToken
      refreshToken
      addresses {
        _id
        deliveryAddress
        details
        label
        selected
        isActive
      }
      status
      permittedPaymentOptions {
        method
        label
      }
      selectedPaymentMethod
      cart {
        orderDeliverySlot {
          deliveryString
          slotId
          date
        }
      }
      GST
      onlinePaymentProvider
      favourites
      canApplyReferral
      nestPassRenewalEnabled
      deviceModel
      deviceType
      deviceOS
    }
    paymentStatus
    paymentMethod
    onlinePaymentStatus
    paidAmount
    orderAmount
    orderDate
    deliveryDate
    billDetails {
      itemsTotal
      deliveryCharge
      grandTotal
      totalSaving
      handlingCharge
      itemSavings
      itemsMrp
      chargesWaived
      couponDiscount
      referralInfo {
        applied
        amount
        code
        message
        referrerId
        percentage
      }
      walletInfo {
        applied
        amount
        message
      }
      couponInfo {
        applied
        amount
        code
        message
        cancellationApplied
        limitRate
        daysRange
      }
      nestInfo {
        applied
        amount
        message
        couponRefundAmount
        couponRefundAccomodated
      }
      cancelledInfo {
          referralInfo {
            applied
            amount
            code
            message
            referrerId
            percentage
          }
          walletInfo {
            applied
            amount
            message
          }
          couponInfo {
            applied
            amount
            code
            message
            cancellationApplied
            limitRate
            daysRange
          }
          nestInfo {
            applied
            amount
            message
            couponCancellationAmount
            couponCancellationAccomodated
          }
        }
        refund
        premiumCustomerSaving
      }
    deliveryAddress {
      _id
      location {
        coordinates
      }
      deliveryAddress
      details
      label
      selected
      isActive
    }
    isOrderModified
    refundStatus
    canceledRefundStatus
    cancelledRefundAmount
    orderState {
      status
      workerStatus
      ppWorkerAssigned
      ppWorkerAssignedEmail
      billingWorkerAssigned
      billingWorkerAssignedEmail
      riderAssigned
      riderAssignedEmail
      lockedRider
      lockedRiderEmail
    }
    invoiceId
    deliveredImage
    customerDeliverySlot {
      name
      leadTime
      timeSlot {
        start
        end
        leadTime
        _id
      }
    }
    deliveryModifications {
      from
      to
      by
      on
      reason
    }
    isOrderRejected
    orderRejectedReason
  }
}`


export const GetWorkersByOrderStatus = `
query GetWorkersByOrderStatus($orderId: String!) {
  getWorkersByOrderStatus(orderId: $orderId) {
    _id
    name
    email
    phone
    workerType
    available
    isActive
  }
}`
export const GetRiderConfigForLS = `
query GetRiderConfigForLS {
  getRiderConfigForLS {
    expansionRatio
    thresholdFactor
    locationUpdateTimeInSecs
    deliveryDistanceForNotificationInMts
  }
}`
export const GetAllRidersForLocalStore=`
query GetAllRidersForLocalStore {
  getAllRidersForLocalStore {
    _id
    name
    email
    phone
    workerType
    available
    isActive
    jwtToken
    storeId
    storeName
  }
}`
export const GetRiderOrderDetailsForRiderStatsById=`
query GetRiderOrderDetailsForRiderStatsById($skip: Int!, $limit: Int!, $riderStatsId: String) {
  getRiderOrderDetailsForRiderStatsById(skip: $skip, limit: $limit, riderStatsId: $riderStatsId) {
    _id
    email
    riderId
    startedAt
    endedAt
    deliveryDateString
    store
    ordersCount
    ordersFullfilled
    rideStatus
    reason
    riderOrders {
      orderId
      status
      when
      customerName
      customerPhone
      deliveryAddress
      orderAmount
    }
  }
}`
export const GetRiderStatsByRiderIdStatusAndDeliverySlot=`
query GetRiderStatsByRiderIdStatusAndDeliverySlot($rideStatsInput: RideStatsInput!, $skip: Int!, $limit: Int!) {
  getRiderStatsByRiderIdStatusAndDeliverySlot(rideStatsInput: $rideStatsInput, skip: $skip, limit: $limit) {
    rideStat {
      _id
      email
      riderId
      startedAt
      endedAt
      deliveryDateString
      store
      ordersCount
      ordersFullfilled
      rideStatus
      reason
      riderOrders {
        orderId
        status
        when
        customerName
        customerPhone
        deliveryAddress
        orderAmount
      }
    }
    totalCount
  }
}`
export const GetOrdersByWorkerEmail = `
query GetOrdersByWorkerEmail($email: String!, $skip: Int!, $limit: Int!) {
  getOrdersByWorkerEmail(email: $email, skip: $skip, limit: $limit) {
    orderWorkerStatus {
      _id
      customerId
      orderDate
      deliveryDate
      completionTime
      itemsCount
      orderStatus
      orderAmount
      localStore
      centralStore
      orderState {
        status
        workerStatus
        ppWorkerAssigned
        ppWorkerAssignedEmail
        billingWorkerAssigned
        billingWorkerAssignedEmail
        riderAssigned
        riderAssignedEmail
      }
    }
    totalCount
  }
}`
export const GetWorkerDetailsById = `
query GetWorkerDetailsById($workerId: String) {
  getWorkerDetailsById(workerId: $workerId) {
    _id
    available
    email
    name
    phone
    storeName
  }
}`
export const GetReplenishableProductsForWorker = `
query GetReplenishableProductsForWorker($skip: Int!, $limit: Int!) {
  getReplenishableProductsForWorker(skip: $skip, limit: $limit) {
    products {
      _id
      name
      skuId
      stockId
      localQty
      sortOrder
      minimumQty
      defaultLSQty
      replenishQty
    }
    totalCount
  }
}`
export const GetReplenishRequest = `
query GetReplenishRequest($replenishRequestId: String!) {
  getReplenishRequest(replenishRequestId: $replenishRequestId) {
    _id
    localStore
    localStoreName
    centralStore
    centralStoreName
    requestedItems {
      productId
      skuId
      stockId
      requestedQty
      approvedQty
      receivedQty
      Stock {
        _id
        storeId
        quantity
        name
      }
      requestedItemStates {
        requestedItemStatus
        requestedItemStatusString
        reason
        reasonString
      }
    }
    requestedByEmail
    requestedBy
    approvedByEmail
    approvedBy
    receivedByEmail
    receivedBy
    requestedDate
    approvedDate
    sendDate
    receivedDate
    requestStates {
      type
      requestStatus
      requestStatusString
    }
    status
    statusString
    itemCount {
      requestedCount
      approvedCount
      receivedCount
    }
    comments
  }
}`
export const GetAllReplenishRequests = `
query GetAllReplenishRequests($status: Int!, $limit: Int!, $skip: Int!) {
  getAllReplenishRequests(status: $status, limit: $limit, skip: $skip) {
    repleshishRequestSummary {
      _id
      approvedByEmail
      approvedDate
      centralStore
      centralStoreName
      itemCount {
        approvedCount
        receivedCount
        requestedCount
      }
      localStore
      localStoreName
      receivedByEmail
      receivedDate
      requestedByEmail
      requestedDate
      status
      statusString
    }
    totalCount
  }
}`
export const getskuforprodict = `
query GetSkusForProduct($productId: String, $storeId: String) {
  getSkusForProduct(productId: $productId, storeId: $storeId) {
    Stock {
      _id
      name
      quantity
      storeId
    }
    _id
    barcode
    discount
    isActive
    localStocks {
      defaultLSQty
      quantity
      replenishQty
      skuId
      storeId
    }
    minimumQty
    measure
    mrp
    prices {
      customerType
      sellingPrice
    }
    productId
    stockId
    stockUnits
    storeId
    unit
  }
}`
export const searchproductls = `
query SearchProductsLS($text: String!, $skip: Int!, $limit: Int!) {
  searchProductsLS(text: $text, skip: $skip, limit: $limit) {
    products {
      _id
      name
      description
      aliases
      images
      defaultImage
      isActive
      category {
        _id
        name
        isActive
        images
        subcategories {
          _id
          name
          description
          isActive
          images
          categoryId
        }
        description
      }
      catalog {
        _id
        name
        description
        isActive
        parcelable
      }
      sortOrder
      hsn
      isNewProduct
      displayName
      skus {
        _id
        storeId
        productId
        discount
        barcode
        isActive
        mrp
        prices {
          customerType
          sellingPrice
        }
        unit
        measure
        minimumQty
        stockId
        stockUnits
        Stock {
          _id
          storeId
          quantity
          name
        }
        localStocks {
          storeId
          skuId
          quantity
          replenishQty
          defaultLSQty
        }
      }
    }
    totalCount
  }
}
`
export const searchproductforcs = `
query SearchProductsCS($text: String!, $skip: Int!, $limit: Int!) {
  searchProductsCS(text: $text, skip: $skip, limit: $limit) {
    products {
      name
      _id
      aliases
      catalog {
        _id
        isActive
        description
        name
        parcelable
      }
      category {
        _id
        description
        images
        isActive
        name
        subcategories {
          _id
          categoryId
          description
          images
          isActive
          name
        }
      }
      defaultImage
      description
      displayName
      hsn
      images
      isActive
      isNewProduct
      skus {
        Stock {
          _id
          name
          quantity
          storeId
        }
        _id
        barcode
        discount
        isActive
        localStocks {
          quantity
          replenishQty
          skuId
          storeId
        }
        measure
        minimumQty
        mrp
        productId
        stockId
        stockUnits
        storeId
        unit
      }
      sortOrder
    }
    totalCount
  }
}`
export const getskuforproduct = `
{
  query GetSkusForProduct($productId: String, $storeId: String) {
    getSkusForProduct(productId: $productId, storeId: $storeId) {
      Stock {
        _id
        name
        quantity
        storeId
      }
      _id
      barcode
      discount
      isActive
      localStocks {
        defaultLSQty
        quantity
        replenishQty
        skuId
        storeId
      }
      minimumQty
      measure
      mrp
      prices {
        customerType
        sellingPrice
      }
      productId
      stockId
      stockUnits
      storeId
      unit
    }
  }`
export const getsubcategory = `
query GetSubCategories($categoryId: String!) {
  getSubCategories(categoryId: $categoryId) {
    _id
    name
    description
    isActive
    images
    categoryId
  }
}`
export const getallworker = `
query GetAllWorkersForLocalStore {
  getAllWorkersForLocalStore {
    _id
    name
    email
    phone
    workerType
    available
    isActive
    storeId
    storeName
  }
}`
export const getWorkerInProgressOrders = `
query GetWorkerInProgressOrders($skip: Int!, $limit: Int!) {
  getWorkerInProgressOrders(skip: $skip, limit: $limit) {
    _id
    customerId
    orderDate
    deliveryDate
    completionTime
    itemsCount
    orderStatus
    orderAmount
    localStore
    centralStore
    isOrderRejected
    orderRejectedReason
  }
}`
export const getworkerassignedorder = `query GetWorkerAssignedOrders($skip: Int!, $limit: Int!) {
  getWorkerAssignedOrders(skip: $skip, limit: $limit) {
    orders {
      _id
      centralStore
      completionTime
      customerId
      deliveryAddress {
        _id
        deliveryAddress
        details
        isActive
        label
        location {
          coordinates
        }
        selected
      }
      deliveryDate
      itemsCount
      localStore
      orderAmount
      orderDate
      orderStatus
      isOrderRejected
      orderRejectedReason
    }
    totalCount
  }
}`

export const getworkerordercompleted = `
query GetWorkerCompletedOrders($skip: Int!, $limit: Int!) {
  getWorkerCompletedOrders(skip: $skip, limit: $limit) {
    orders {
      deliveryAddress {
        _id
        location {
          coordinates
        }
        deliveryAddress
        details
        label
        selected
        isActive
      }
      _id
      centralStore
      completionTime
      customerId
      deliveryDate
      itemsCount
      localStore
      orderAmount
      orderDate
      orderStatus
    }
    totalCount
  }
}`
export const getOrderDetailsforworker = `
query GetOrderDetailsById($orderId: String!) {
  getOrderDetailsById(orderId: $orderId) {
    _id
    items {
      productId
      skuId
      name
      description
      image
      quantity
      mrp
      sellingPrice
      prices {
        customerType
        sellingPrice
      }
      status
      measure
      unit
      packingChecked
      billingChecked
      oldSp
      oldCost
      refundString
      isOfferItem
    }
    customerType
    customer {
      _id
      name
      phone
      email
      gender
      nativePlace
      customerType
      isActive
      jwtToken
      refreshToken
      addresses {
        _id
        deliveryAddress
        details
        label
        selected
        isActive
      }
      status
      permittedPaymentOptions {
        method
        label
      }
      selectedPaymentMethod
      cart {
        orderDeliverySlot {
          deliveryString
          slotId
          date
        }
      }
      GST
      onlinePaymentProvider
      favourites
      canApplyReferral
      nestPassRenewalEnabled
      deviceModel
      deviceType
      deviceOS
    }
    paymentStatus
    paymentMethod
    onlinePaymentStatus
    paidAmount
    orderAmount
    orderDate
    deliveryDate
    billDetails {
      itemsTotal
      deliveryCharge
      grandTotal
      totalSaving
      handlingCharge
      itemSavings
      itemsMrp
      chargesWaived
      couponDiscount
      referralInfo {
        applied
        amount
        code
        message
        referrerId
        percentage
      }
      walletInfo {
        applied
        amount
        message
      }
      couponInfo {
        applied
        amount
        code
        message
        cancellationApplied
        limitRate
        daysRange
      }
      nestInfo {
        applied
        amount
        message
        couponRefundAmount
        couponRefundAccomodated
      }
      cancelledInfo {
          referralInfo {
            applied
            amount
            code
            message
            referrerId
            percentage
          }
          walletInfo {
            applied
            amount
            message
          }
          couponInfo {
            applied
            amount
            code
            message
            cancellationApplied
            limitRate
            daysRange
          }
          nestInfo {
            applied
            amount
            message
            couponCancellationAmount
            couponCancellationAccomodated
          }
        }
        refund
        premiumCustomerSaving
      }
    deliveryAddress {
      _id
      location {
        coordinates
      }
      deliveryAddress
      details
      label
      selected
      isActive
    }
    isOrderModified
    refundStatus
    canceledRefundStatus
    cancelledRefundAmount
    orderState {
      status
      workerStatus
      ppWorkerAssigned
      ppWorkerAssignedEmail
      billingWorkerAssigned
      billingWorkerAssignedEmail
      riderAssigned
      riderAssignedEmail
      lockedRider
      lockedRiderEmail
    }
    invoiceId
    deliveredImage
    customerDeliverySlot {
      name
      leadTime
      timeSlot {
        start
        end
        leadTime
        _id
      }
    }
    deliveryModifications {
      from
      to
      by
      on
      reason
    }
    isOrderRejected
    orderRejectedReason
  }
}`
export const worlerWorkinpending = `
query GetWorkerInProgressOrders($skip: Int!, $limit: Int!) {
  getWorkerInProgressOrders(skip: $skip, limit: $limit) {
    orders {
      _id
      customerId
      orderDate
      deliveryDate
      completionTime
      itemsCount
      orderStatus
      orderAmount
      localStore
      centralStore
      deliveryAddress {
        _id
        deliveryAddress
        details
        isActive
        label
        location {
          coordinates
        }
        selected
      }
         isOrderRejected
    orderRejectedReason
    }
    totalCount
  }
}`
export const workerdashboard = `
query GetWorkerDashBoard {
  getWorkerDashBoard {
    assignedOrdersCount
    completedOrdersCount
    inProgressOrdersCount
    available
  }
}`

export const getallorder = `
query GetAllOrders($limit: Int!, $skip: Int!) {
 getAllOrders(limit: $limit, skip: $skip) {
  totalCount
    orders {
      _id
      customerId
      customerName
      customerPhone
      orderDate
      deliveryDate
      completionTime
      itemsCount
      orderStatus
      orderAmount
      localStore
      centralStore
      billDetails {
        itemsTotal
        deliveryCharge
        grandTotal
        totalSaving
        handlingCharge
        itemSavings
        itemsMrp
        chargesWaived
        couponDiscount
        referralInfo {
          applied
          amount
          code
          message
          referrerId
          percentage
        }
        walletInfo {
          applied
          amount
          message
        }
        couponInfo {
          applied
          amount
          code
          message
          cancellationApplied
          limitRate
          daysRange
        }
        nestInfo {
          applied
          amount
          message
          couponRefundAmount
          couponRefundAccomodated
        }
        cancelledInfo {
          referralInfo {
            applied
            amount
            code
            message
            referrerId
            percentage
          }
          walletInfo {
            applied
            amount
            message
          }
          couponInfo {
            applied
            amount
            code
            message
            cancellationApplied
            limitRate
            daysRange
          }
          nestInfo {
            applied
            amount
            message
            couponCancellationAmount
            couponCancellationAccomodated
          }
        }
        refund
        premiumCustomerSaving
      }
      deliveryAddress {
        _id
        location {
          coordinates
        }
        deliveryAddress
        details
        label
        selected
        isActive
      }
      orderState {
        status
        workerStatus
        ppWorkerAssigned
        ppWorkerAssignedEmail
        billingWorkerAssigned
        billingWorkerAssignedEmail
        riderAssigned
        riderAssignedEmail
        lockedRider
        lockedRiderEmail
      }
      invoiceId
      deliveredImage
      paymentMethod
      paymentStatus
      deliveryModifications {
        from
        to
        by
        on
        reason
      }
      refundStatus
      canceledRefundStatus
    }
  }
}`
export const GetSuperAdminDashBoard = `
query Query {
  getSuperAdminDashboard {
    centralStoreCount
    totalOrders
    pendingOrders
    completedOrders
    categoryCount
    productCount
  }
}
`
export const getcatlog = `
query GetCatalogs($skip: Int!, $limit: Int!) {
  getCatalogs(skip: $skip, limit: $limit) {
    catalogs {
      _id
      name
      description
      isActive
      parcelable
    }
    totalCount
  }
}`

export const getsinglecatlog = `query GetCategory($categoryId: String!) {
  getCategory(categoryId: $categoryId) {
  _id
    name
    isActive
    images
    subcategories {
      _id
      name
      description
      isActive
      images
      categoryId
      sortOrder
    }
    description
    sortOrder
  }
}`
export const getallcentralStore = `
query GetAllCentralStores {
  getAllCentralStores {
    _id
    name
    type
    code
    address
    city
    location {
      coordinates
    }
    admins {
      _id
      name
      email
      phone
      userType
      isActive
      jwtToken
      createdBy
      storeId
      storeName
    }
    deliveryBounds {
      coordinates
    }
    landingPage {
      _id
      landingPageDisplays {
        deviceType
        _id
        displays {
          _id
          displayType
          enabled
          rows
          columns
          displayPosition
        }
      }
    }
  }
}`

export const getallcategories = `
query GetCategories($skip: Int!, $limit: Int!) {
  getCategories(skip: $skip, limit: $limit) {
    categories {
      _id
      name
      isActive
      images
      subcategories {
        _id
        name
        description
        isActive
        images
        categoryId
        sortOrder
      }
      description
      sortOrder
    }
    totalCount
  }
}`

export const getsinglecategory = `query GetCategory($categoryId: String!) {
  getCategory(categoryId: $categoryId) {
    _id
    name
    isActive
    images
    subcategories {
      _id
      name
      description
      isActive
      images
      categoryId
      sortOrder
    }
    description
    sortOrder
  }
}`

export const getallcentralstoreadmin = `query GetCSAdminsForAllStores {
  getCSAdminsForAllStores {
    _id
    name
    email
    phone
    userType
    isActive
    jwtToken
    createdBy
    storeId
    storeName
  }
}`

export const getcsadmindashboard = `query GetCSAdminDashBoard {
  getCSAdminDashBoard {
    completedOrders
    localStoreCount
    pendingOrders
    productCount
    replenishCount
    storeCity
    storeName
    totalOrders
  }
}`

export const getproductsforcs = `
query GetProductsForCS($storeId: String!, $limit: Int!, $skip: Int!) {
  getProductsForCS(storeId: $storeId, limit: $limit, skip: $skip) {
    totalCount
    products {
      _id
      aliases
      catalog {
        _id
        description
        isActive
        name
        parcelable
      }
      category {
        _id
        description
        images
        isActive
        name
        subcategories {
          _id
          categoryId
          description
          images
          isActive
          name
        }
      }
      defaultImage
      description
      displayName
      hsn
      images
      isActive
      isNewProduct
      name
      skus {
        Stock {
          _id
          name
          quantity
          storeId
        }
        _id
        barcode
        discount
        isActive
        localStocks {
          defaultLSQty
          quantity
          replenishQty
          skuId
          storeId
        }
        measure
        minimumQty
        mrp
        prices {
          customerType
          sellingPrice
        }
        productId
        stockUnits
        stockId
        storeId
        unit
      }
    }
  }
}
`
export const getalllocalstore = `
query GetAllLocalStores {
  getAllLocalStores {
    _id
    name
    type
    code
    address
    city
    location {
      coordinates
    }
    admins {
      _id
      name
      email
      phone
      userType
      isActive
      jwtToken
      createdBy
      storeId
      storeName
      contact_address
    }
    deliveryBounds {
      coordinates
    }
    landingPage {
      _id
      landingPageDisplays {
        deviceType
        _id
        displays {
          _id
          displayType
          enabled
          rows
          columns
          displayPosition
        }
      }
    }
    landingPageDisplayConfigs {
      _id
      displayName
      displayType
    }
    premiumCustomerConfig {
      purchaseAmount
      expiryInMonths
      daysOfPurchase
      activated
      message
    }
    removeUpgradedCustomerSlot {
      start
      end
      _id
    }
    customerDeliverySlot {
      name
      leadTime
      timeSlot {
        start
        end
        _id
      }
    }
   
    isActive
  }
}`
export const getproductsforsa = `query GetProducts($limit: Int!, $skip: Int!) {
  getProducts(limit: $limit, skip: $skip) {
    products {
      _id
      name
      description
      aliases
      images
      defaultImage
      isActive
      category {
        _id
        name
        isActive
        images
        subcategories {
          _id
          name
          description
          isActive
          images
          categoryId
        }
        description
      }
      catalog {
        _id
        name
        description
        isActive
        parcelable
      }
      sortOrder
      catalogDefault
      hsn
      CGST
      IGST
      SGST
      Exempted
      isNewProduct
      displayName
      skus {
        _id
        storeId
        productId
        discount
        barcode
        isActive
        mrp
        prices {
          customerType
          sellingPrice
        }
        unit
        measure
        minimumQty
        stockId
        stockUnits
        Stock {
          _id
          storeId
          quantity
          name
          store
        }
        localStocks {
          storeId
          skuId
          quantity
          replenishQty
          defaultLSQty
        }
      }
      offerImage
      offerEnabled
    }
    totalCount
  }
}`
export const getllocaladmins = `query GetStoreAdmins($storeId: String!) {
  getStoreAdmins(storeId: $storeId) {
    _id
    address
    admins {
      _id
      createdBy
      email
      isActive
      name
      phone
      storeId
      storeName
      userType
    }
    city
    code
    deliveryBounds {
      coordinates
    }
    location {
      coordinates
    }
    name
    type
  }
}`
export const getproducts = `
query GetProducts($limit: Int!, $skip: Int!) {
  getProducts(limit: $limit, skip: $skip) {
    products {
      _id
      name
      description
      aliases
      images
      defaultImage
      isActive
      category {
        _id
        name
        isActive
        images
        subcategories {
          _id
          name
          description
          isActive
          images
          categoryId
        }
        description
      }
      catalog {
        _id
        name
        description
        isActive
        parcelable
      }
      sortOrder
      catalogDefault
      hsn
      CGST
      IGST
      SGST
      isNewProduct
      displayName
      skus {
        _id
        storeId
        productId
        discount
        barcode
        isActive
        mrp
        prices {
          customerType
          sellingPrice
        }
        unit
        measure
        minimumQty
        stockId
        stockUnits
        Stock {
          _id
          storeId
          quantity
          name
          store
        }
        localStocks {
          storeId
          skuId
          quantity
          replenishQty
          defaultLSQty
        }
      }
      offerImage
      offerEnabled
    }
    totalCount
  }
}`

export const getlsadmin = `query Query {
  getLSAdminsForStore {
    _id
    email
    name
    phone
    storeId
    storeName
    isActive
    createdBy
    contact_address
  }
}`

export const gettallcustomers = `
query GetCustomersForCentralStore($limit: Int!, $skip: Int!) {
  getCustomersForCentralStore(limit: $limit, skip: $skip) {
    customers {
      _id
      name
      phoneNumber
      addresses {
        _id
        location {
          coordinates
        }
        deliveryAddress
        details
        label
        selected
        isActive
      }
      orderCount
      localStores
      customerType
    }
    totalCount
  }
}`

export const getCustomerReportWithOrderCount = `
query GetCustomerReportWithOrderCount($skip: Int!, $limit: Int!) {
  getCustomerReportWithOrderCount(skip: $skip, limit: $limit) {
    customers {
      _id
      name
      phone
      phoneIsVerified
      email
      createdAt
      updatedAt
      orderCount
    }
    totalCount
  }
}`

//local admin

export const getlsadminDashboard = `
query GetLSAdminDashBoard {
  getLSAdminDashBoard {
    completedOrders
    pendingOrders
    productCount
    replenishCount
    storeCity
    storeName
    totalOrders
  }
}`

export const getModifiedOrderDetails =`
query GetModifiedOrderDetails($orderId: String!) {
  getModifiedOrderDetails(orderId: $orderId) {
    _id
    items {
      productId
      skuId
      name
      description
      image
      quantity
      mrp
      sellingPrice
      prices {
        customerType
        sellingPrice
      }
      status
      measure
      unit
      packingChecked
      billingChecked
      oldSp
      oldCost
      refundString
      isOfferItem
    }
    customer {
      _id
      name
      phone
      email
      gender
      nativePlace
      customerType
      isActive
      jwtToken
      refreshToken
      addresses {
        _id
        deliveryAddress
        details
        label
        selected
        isActive
      }
      status
      permittedPaymentOptions {
        method
        label
      }
      selectedPaymentMethod
      cart {
        orderDeliverySlot {
          deliveryString
          slotId
          date
        }
      }
      GST
      onlinePaymentProvider
      favourites
      canApplyReferral
      nestPassRenewalEnabled
      deviceModel
      deviceType
      deviceOS
    }
    paymentStatus
    paymentMethod
    orderStatus
    paidAmount
    orderAmount
    orderDate
    deliveryDate
    billDetails {
      itemsTotal
      deliveryCharge
      grandTotal
      totalSaving
      handlingCharge
      itemSavings
      itemsMrp
      chargesWaived
      couponDiscount
      referralInfo {
        applied
        amount
        code
        message
        referrerId
        percentage
      }
      walletInfo {
        applied
        amount
        message
      }
      couponInfo {
        applied
        amount
        code
        message
        cancellationApplied
        limitRate
        daysRange
      }
      nestInfo {
        applied
        amount
        message
        couponRefundAmount
        couponRefundAccomodated
      }
      cancelledInfo {
        referralInfo {
          applied
          amount
          code
          message
          referrerId
          percentage
        }
        walletInfo {
          applied
          amount
          message
        }
        couponInfo {
          applied
          amount
          code
          message
          cancellationApplied
          limitRate
          daysRange
        }
        nestInfo {
          applied
          amount
          message
          couponCancellationAmount
          couponCancellationAccomodated
        }
      }
      refund
      premiumCustomerSaving
    }
    deliveryAddress {
      _id
      location {
        coordinates
      }
      deliveryAddress
      details
      label
      selected
      isActive
    }
    isOrderModified
    refundAmount
    refundStatus
    totalRefundPending
    totalRefundProccessed
    modifications {
      modifiedBy
      modifiedOn
      originalItems {
        productId
        skuId
        name
        description
        image
        quantity
        mrp
        sellingPrice
        status
        measure
        unit
        packingChecked
        billingChecked
        oldSp
        oldCost
        refundString
        isOfferItem
      }
      modifiedItems {
        productId
        skuId
        name
        description
        image
        quantity
        mrp
        sellingPrice
        status
        measure
        unit
        packingChecked
        billingChecked
        oldSp
        oldCost
        refundString
        isOfferItem
      }
      originalBillDetails {
        itemsTotal
        deliveryCharge
        grandTotal
        totalSaving
        handlingCharge
        itemSavings
        itemsMrp
        chargesWaived
        couponDiscount
        refund
        premiumCustomerSaving
      }
      modifiedBillDetails {
        itemsTotal
        deliveryCharge
        grandTotal
        totalSaving
        handlingCharge
        itemSavings
        itemsMrp
        chargesWaived
        couponDiscount
        refund
        premiumCustomerSaving
      }
      refundAmount
      instructions
      isRejected
      rejection {
        rejectedBy
        reason
        date
      }
    }
  }
}`
export const getlocaladminproducts = `
query GetProductsForLS($storeId: String!, $limit: Int!, $skip: Int!) {
  getProductsForLS(storeId: $storeId, limit: $limit, skip: $skip) {
    products {
      _id
      name
      description
      aliases
      images
      defaultImage
      isActive
      category {
        _id
        name
        isActive
        images
        subcategories {
          _id
          name
          description
          isActive
          images
          categoryId
        }
        description
      }
      catalog {
        _id
        name
        description
        isActive
        parcelable
      }
      sortOrder
      hsn
      isNewProduct
      displayName
      skus {
        _id
        storeId
        productId
        discount
        barcode
        isActive
        mrp
        prices {
          customerType
          sellingPrice
        }
        unit
        measure
        minimumQty
        stockId
        stockUnits
        Stock {
          _id
          storeId
          quantity
          name
        }
        localStocks {
          storeId
          skuId
          quantity
          replenishQty
          defaultLSQty
        }
      }
    }
    totalCount
  }
}`
export const getOrders = `query Orders($page:Int){
    allOrders(page:$page){
      _id
      deliveryAddress
      deliveryCharges
      orderAmount
      paidAmount
      paymentMethod
      orderId
      user{
        _id
        name
        email
        phone
      }
      items{
        _id
        food{
          _id
          title
          description
          image
        }
        variation{
          _id
          title
          price
          discounted
        }
        addons{
          _id
          title
          description
          quantityMinimum
          quantityMaximum
          options{
            _id
            title
            price
          }
        }
        specialInstructions
        quantity
      }
      reason
      status
      paymentStatus
      orderStatus
      createdAt
      review{
        _id
        rating
        description
      }
      rider{
        _id
        name
      }
    }
  }`
export const AnalyzeCohorts = `
  query AnalyzeCohorts($startDate: String!, $endDate: String!, $cohortBy: CohortDimension, $groupBy: TimeDimension, $customerTypeFilter: [Int]) {
    analyzeCohorts(startDate: $startDate, endDate: $endDate, cohortBy: $cohortBy, groupBy: $groupBy, customerTypeFilter: $customerTypeFilter) {
      cohortLabel
      installedMonth
      totalInstallperMonth
      timePeriods {
        periodLabel
        orderedMonth
        totalOrders
        orderAmount
        activeCustomers
        firstOrderCustomers
        conversionRate
        ordersGrowthPercent
        amountGrowthPercent
      }
    }
  }`
export const GetMonthlyOrderMetrics = `
query GetMonthlyOrderMetrics($startDate: String!, $endDate: String!, $customerTypeFilter: [Int]) {
  getMonthlyOrderMetrics(startDate: $startDate, endDate: $endDate, customerTypeFilter: $customerTypeFilter) {
    orderedMonth
    totalOrders
    orderAmount
    uniqueCustomers
    firstOrderCustomers
    repeatedCustomers
    totalInstalls
    conversionRate
  }
}`

export const GetWeeklySalesReportByCategory = `
query GetWeeklySalesReportByCategory($categoryId: String) {
  getWeeklySalesReportByCategory(input: { categoryId: $categoryId }) {
    periodLabel
    startDate
    endDate
    totalItemsCount
    items {
      stockName
      monSales
      tueSales
      wedSales
      thuSales
      friSales
      satSales
      sunSales
    }
  }
}`
